import React from 'react';

import { Typography } from '@mui/material';

export const TranscriptSentenceTranscription = ({ sentence }: { sentence: string }) => {
  return (
    <Typography
      sx={{
        fontSize: '14px',
        span: {
          backgroundColor: '#1BFFAF',
          padding: '2px 8px',
          borderRadius: '8px',
        },
      }}
      dangerouslySetInnerHTML={{ __html: sentence }}
    />
  );
};
